export const SITE = {
  name: "Sagos",
  domain: "www.sagos.consulting",
  tagline: "Financial Consulting & Advisory",
  founded: "2016",
  phone: "+1 (248) 220-6979",
  phoneHref: "tel:+12482206979",
  email: "advisory@sagos.consulting",
  address: {
    line1: "77 Monroe Center St. NW, Suite 600",
    line2: "Grand Rapids, MI 49503",
  },
  logo: "/sagos-logo.png",
  images: {
    hero: "https://images.unsplash.com/photo-1526948531399-320e7e40f0ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxmaW5hbmNlJTIwZXhlY3V0aXZlJTIwY29uc3VsdGluZyUyMG9mZmljZXxlbnwwfHx8fDE3ODM2MjAyOTh8MA&ixlib=rb-4.1.0&q=85",
    about: "https://images.unsplash.com/photo-1542744095-fcf48d80b0fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxmaW5hbmNlJTIwZXhlY3V0aXZlJTIwY29uc3VsdGluZyUyMG9mZmljZXxlbnwwfHx8fDE3ODM2MjAyOTh8MA&ixlib=rb-4.1.0&q=85",
    services: "https://images.unsplash.com/photo-1707157284454-553ef0a4ed0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxmaW5hbmNlJTIwZXhlY3V0aXZlJTIwY29uc3VsdGluZyUyMG9mZmljZXxlbnwwfHx8fDE3ODM2MjAyOTh8MA&ixlib=rb-4.1.0&q=85",
    location: "https://images.unsplash.com/photo-1532193699930-edd8d3fa5b6e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxncmFuZCUyMHJhcGlkcyUyMHNreWxpbmV8ZW58MHx8fHwxNzgzNjIwMjk4fDA&ixlib=rb-4.1.0&q=85",
  },
};

export const SERVICES = [
  {
    key: "wealth",
    title: "Wealth Management",
    desc: "Bespoke portfolio construction and disciplined asset allocation engineered around your long-term objectives.",
    icon: "TrendingUp",
  },
  {
    key: "planning",
    title: "Financial Planning",
    desc: "Comprehensive roadmaps covering cash flow, education funding, insurance and generational wealth transfer.",
    icon: "Compass",
  },
  {
    key: "tax",
    title: "Tax Advisory",
    desc: "Proactive, year-round strategies that minimize liability and keep more of what you earn working for you.",
    icon: "Receipt",
  },
  {
    key: "retirement",
    title: "Retirement Strategy",
    desc: "Income modeling and drawdown planning designed to protect your lifestyle for decades to come.",
    icon: "Landmark",
  },
  {
    key: "business",
    title: "Business Consulting",
    desc: "Capital structure, succession and valuation advisory for founders and closely-held enterprises.",
    icon: "Briefcase",
  },
  {
    key: "estate",
    title: "Estate & Legacy",
    desc: "Structures that preserve, protect and transfer wealth precisely as you intend across generations.",
    icon: "ScrollText",
  },
];
